import { CSSProperties } from 'styled-components';

const classes: { [key: string]: CSSProperties } = {
    'h1-root': {
        fontSize: '2rem',
        fontWeight: '400',
        color: 'var(--main-blue-color)',
        margin: '0',
        textAlign: 'center',
        width: '100%',
        fontFamily: 'var(--ion-font-family)'
    },
    'h2-root': {
        fontSize: '1.5rem',
        fontWeight: '400',
        color: 'var(--Typography-h2-color)',
        margin: '0',
        textAlign: 'center',
        width: '100%',
        fontFamily: 'var(--ion-font-family)'
    },
    'h3-root': {
        fontSize: '1.125rem',
        fontWeight: 600,
        color: 'var(--color-primary)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0',
        fontFamily: 'var(--ion-font-family)'
    },
    'h4-root': {
        fontSize: '1rem',
        fontWeight: 500,
        color: 'var(--color-primary)',
        margin: '0',
        fontFamily: 'var(--ion-font-family)'
    },
    'h5-root': {
        color: 'red'
    },
    'h6-root': {
        color: 'red'
    },
    'p-root': {
        color: 'var(--color-black)',
        fontSize: '1rem',
        fontWeight: '400',
        lineHeight: '1.5rem',
        margin: '0',
        fontFamily: 'var(--ion-font-family)'
    },
    'span-root': {
        color: 'red'
    }
};

interface Props {
    children: any;
    variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
    sx?: CSSProperties;
    className?: string;
    onClick?: () => void;
}

export function Typography({
    children,
    variant = 'p',
    sx,
    className,
    onClick
}: Props): JSX.Element {
    const getElement = (): JSX.Element => {
        switch (variant) {
            case 'h1':
                return (
                    <h1
                        className={className}
                        onClick={() => (onClick ? onClick() : {})}
                        style={{ ...classes['h1-root'], ...sx }}>
                        {children}
                    </h1>
                );
            case 'h2':
                return (
                    <h2
                        className={className}
                        onClick={() => (onClick ? onClick() : {})}
                        style={{ ...classes['h2-root'], ...sx }}>
                        {children}
                    </h2>
                );
            case 'h3':
                return (
                    <h3
                        className={className}
                        onClick={() => (onClick ? onClick() : {})}
                        style={{ ...classes['h3-root'], ...sx }}>
                        {children}
                    </h3>
                );
            case 'h4':
                return (
                    <h4
                        className={className}
                        onClick={() => (onClick ? onClick() : {})}
                        style={{ ...classes['h4-root'], ...sx }}>
                        {children}
                    </h4>
                );
            case 'h5':
                return (
                    <h5
                        className={className}
                        onClick={() => (onClick ? onClick() : {})}
                        style={{ ...classes['h5-root'], ...sx }}>
                        {children}
                    </h5>
                );
            case 'h6':
                return (
                    <h6
                        className={className}
                        onClick={() => (onClick ? onClick() : {})}
                        style={{ ...classes['h6-root'], ...sx }}>
                        {children}
                    </h6>
                );
            case 'p':
                return (
                    <p
                        className={className}
                        onClick={() => (onClick ? onClick() : {})}
                        style={{ ...classes['p-root'], ...sx }}>
                        {children}
                    </p>
                );
            case 'span':
                return (
                    <span
                        className={className}
                        onClick={() => (onClick ? onClick() : {})}
                        style={{ ...classes['span-root'], ...sx }}>
                        {children}
                    </span>
                );
            default:
                return (
                    <p
                        className={className}
                        onClick={() => (onClick ? onClick() : {})}
                        style={{ ...classes['p-root'], ...sx }}>
                        {children}
                    </p>
                );
        }
    };

    return getElement();
}
